import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Card, Result } from "antd";
import { observer } from "mobx-react-lite";
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/DeniedPage.module.less";
import { DENY_REASON_TEXT } from "@/types/auth/principal";
const DEFAULT_REASON = "NOT_STAFF";
const DeniedPage = observer(() => {
    const { authStore } = getRootStore();
    const reason = authStore.principal?.kind === "denied"
        ? authStore.principal.reason
        : DEFAULT_REASON;
    const { title, description } = DENY_REASON_TEXT[reason];
    const handleReturn = () => {
        authStore.dismissDenied();
    };
    return (_jsx("div", { className: styles.deniedPageContainer, "data-testid": "corp-denied-page", children: _jsx("div", { className: styles.deniedCard, children: _jsx(Card, { children: _jsx(Result, { status: "403", title: title, subTitle: description, extra: _jsx(Button, { type: "primary", onClick: handleReturn, children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A\u043E \u0432\u0445\u043E\u0434\u0443" }) }) }) }) }));
});
DeniedPage.displayName = "DeniedPage";
export default DeniedPage;
